/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DetachMatchPhotoResponse
 */
export interface DetachMatchPhotoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DetachMatchPhotoResponse
     */
    detached: boolean;
}

/**
 * Check if a given object implements the DetachMatchPhotoResponse interface.
 */
export function instanceOfDetachMatchPhotoResponse(value: object): value is DetachMatchPhotoResponse {
    if (!('detached' in value) || value['detached'] === undefined) return false;
    return true;
}

export function DetachMatchPhotoResponseFromJSON(json: any): DetachMatchPhotoResponse {
    return DetachMatchPhotoResponseFromJSONTyped(json, false);
}

export function DetachMatchPhotoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetachMatchPhotoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'detached': json['detached'],
    };
}

export function DetachMatchPhotoResponseToJSON(json: any): DetachMatchPhotoResponse {
    return DetachMatchPhotoResponseToJSONTyped(json, false);
}

export function DetachMatchPhotoResponseToJSONTyped(value?: DetachMatchPhotoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'detached': value['detached'],
    };
}

